"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalizedProps = void 0;
const LocalizedComponent_1 = require("./LocalizedComponent");
const LLContext_1 = require("./LLContext");
const react_1 = require("react");
exports.useLocalizedProps = (props, language) => {
    const languageFromContext = react_1.useContext(LLContext_1.llContext);
    const languageId = language || languageFromContext.languageId;
    const { localize, propsToLocalize, ...propsToSend } = props;
    return {
        languageId,
        ...LocalizedComponent_1.getLocalizedProps(propsToSend, languageId, props.propsToLocalize, props.localize, props.variables)
    };
};
//# sourceMappingURL=useLocalizedProps.js.map